import { Subject } from 'rxjs'

/**
 * this listen to url change
 * basically listen to history.listen
 *
 */
export const urlChange$ = new Subject()
